import { GeneralAttachmentDto, VisualInspectionDto } from "@/core/api/generated/v1";

export class VisualInspectionHelper {
  public static getAllAttachments(entity: VisualInspectionDto): GeneralAttachmentDto[] {
    return (entity.items || [])
      .flatMap((item) => item.attachments || [])
      .concat(entity.attachments || []);
  }
}
